import React from 'react';
import styles from '../../styles/blog/articleContent.module.scss';

export default function ArticleContent({ content }) {
    if (!content) return null;

    return (
        <div
            className={styles.articleContent}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
}
